
import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface InfoTooltipProps {
  content: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  className?: string;
  infoIconColor?: string; // Add this prop
}

const InfoTooltip = ({ 
  content, 
  side = "top", 
  align = "center",
  className = "",
  infoIconColor = "#555555" // Default dark grey
}: InfoTooltipProps) => {
  const handleClick = (e: React.MouseEvent) => {
    // Prevent the click from propagating to parent elements
    e.stopPropagation();
  };

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild onClick={handleClick}>
          <button 
            className={`inline-flex ml-1 hover:text-gray-600 focus:outline-none ${className}`} 
            onClick={e => e.stopPropagation()}
          >
            <Info 
              className="h-3.5 w-3.5" 
              color={infoIconColor} // Apply the custom color
            />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          side={side}
          align={align}
          className="max-w-xs p-3 text-xs bg-black/95 text-white rounded-md border-none font-medium"
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
